import { faHome, faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from 'next/image'
import { twMerge } from 'tailwind-merge'

import { Address, AddressSuggestion } from '@unreserved-frontend-v2/api/generated/graphql/types'
import { getAddressCaption } from '@unreserved-frontend-v2/geolocation/utils/utils'
import Button from '@unreserved-frontend-v2/ui/button/button'
import { FlexCol } from '@unreserved-frontend-v2/ui/flex/flex-col'
import { FlexRow } from '@unreserved-frontend-v2/ui/flex/flex-row'

type mapSize = 'big' | 'small'

const mapDimentions = {
  big: 72,
  small: 44,
}

export const AddressResultRow = ({
  address,
  isMobile = false,
  showEditControls = false,
  allowDelete = true,
  containerClassName,
  onEdit,
  onDelete,
  mapSize = 'small',
}: {
  address: Address | AddressSuggestion
  showEditControls?: boolean
  isMobile?: boolean
  containerClassName?: string
  allowDelete?: boolean
  onEdit?: () => void
  onDelete?: () => void
  mapSize?: mapSize
}) => {
  const isAddressSuggestion = (address as AddressSuggestion).mainText !== undefined
  const mainText = isAddressSuggestion ? (address as AddressSuggestion).mainText : (address as Address).address1
  const caption = isAddressSuggestion
    ? (address as AddressSuggestion).secondaryText
    : getAddressCaption(address as Address)

  const dimension = mapDimentions[mapSize]

  return (
    <FlexRow className={twMerge('items-center gap-x-6 md:gap-x-4', containerClassName)}>
      {isMobile ? (
        <FontAwesomeIcon icon={faHome} />
      ) : (
        <Image src={'/static/images/map.png'} alt="map icon" width={dimension} height={dimension} />
      )}
      <FlexCol className="flex-1 leading-7">
        <h3 className="font-bold">{mainText}</h3>
        {caption}
      </FlexCol>
      {showEditControls ? (
        <FlexRow className="gap-x-2">
          <Button data-testid="edit-address" variant="ghost" className="h-[32px] w-[32px] p-0" onClick={onEdit}>
            <FontAwesomeIcon icon={faPencil} fontSize={14} />
          </Button>
          {allowDelete ? (
            <Button data-testid="delete-address" variant="ghost" className="h-[32px] w-[32px] p-0" onClick={onDelete}>
              <FontAwesomeIcon icon={faTrash} fontSize={14} />
            </Button>
          ) : null}
        </FlexRow>
      ) : null}
    </FlexRow>
  )
}
